exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".example-margin {\n    margin: 0px;\n    height: 8px;\n    width: 100%;\n    background-color: #4CBC5F;\n}\n\n.mat-progress-bar-fill::after {\n    background-color: #3ab792 !important;\n}\n\n.mat-progress-bar-buffer {\n    background-color: #2faa6c !important;\n}\n\n.card {\n    border: 1px solid #dadada;\n    padding: 20px;\n    border-radius: 4px;\n    background-color: #fff;\n}", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// /var/www/_deploy/front-company-testing/2018-09-30-21-57-10/src/app/pages/kanban-timeline/kanban-timeline.component.css
// module id = ../../../../../src/app/pages/kanban-timeline/kanban-timeline.component.css
// module chunks = main